import { computeRoutePdfLength } from "utils/computeRoutePdfLength";
import type { InsertNodeOnEdgeInRoute } from "./types";

export const insertNodeOnEdgeInRoute: InsertNodeOnEdgeInRoute = ({
  geometry,
  edgeIndex,
  pos,
}) => {
  if (edgeIndex < 0 || edgeIndex >= geometry.edges.length) return null;

  const targetEdge = geometry.edges[edgeIndex];
  const maxNodeId = geometry.nodes.reduce(
    (max, node) => Math.max(max, node.id),
    0,
  );
  const newNodeId = maxNodeId + 1;

  const updatedNodes = [
    ...geometry.nodes,
    { id: newNodeId, x: pos.x, y: pos.y },
  ];
  const updatedEdges = [
    ...geometry.edges.slice(0, edgeIndex),
    { from: targetEdge.from, to: newNodeId },
    { from: newNodeId, to: targetEdge.to },
    ...geometry.edges.slice(edgeIndex + 1),
  ];
  const polylineLength = computeRoutePdfLength({
    nodes: updatedNodes,
    edges: updatedEdges,
  });

  return {
    geometry: {
      nodes: updatedNodes,
      edges: updatedEdges,
      polylineLength,
    },
    newNodeId,
  };
};
